import type { ComponentType } from "react";
import { ForumDashboardPanel } from "./ForumDashboardPanel";
import type { ForumDashboardSummary } from "../api/shellApi";

/**
 * Pack-scoped home panels for the tenant "תמונת מצב" / dashboard surface.
 * Register by packKey only — never by tenant id.
 */
export type HomePanel = {
  id: string;
  Component: ComponentType<{ dashboard?: ForumDashboardSummary | null }>;
};

const HOME_PANELS_BY_PACK: Record<string, readonly HomePanel[]> = {
  "forum-kupot": [{ id: "forum-dashboard", Component: ForumDashboardPanel }],
};

export function getHomePanelsForPack(
  packKey: string | null | undefined,
): readonly HomePanel[] {
  if (!packKey) {
    return [];
  }
  return HOME_PANELS_BY_PACK[packKey] ?? [];
}
